/* eslint-disable max-len */
import * as React from 'react';
const CalendarCheckIcon = (props) => (
  <svg fill="none" viewBox="0 0 16 16" {...props}>
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#clip0_4559_17170)"
    >
      <path d="M.5 5.5h15M15.5 8.5V4A1.5 1.5 0 0 0 14 2.5H2A1.5 1.5 0 0 0 .5 4v10A1.5 1.5 0 0 0 2 15.5h4.5M4.5.5v2M11.5.5v2M9.5 13.5l2 2 4-4" />
    </g>
    <defs>
      <clipPath id="clip0_4559_17170">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default CalendarCheckIcon;